import { registerComponentIcon } from '../utils/registerComponentIcon';
import { CalendarTodoRegular as OriginalCalendarTodoRegular } from '@fluentui/react-brand-icons';

export const CalendarTodoRegular = registerComponentIcon(
    'CalendarTodoRegular',
    OriginalCalendarTodoRegular
);
